// Predicates over exercises.exercise_type.
//
// The type ENUM splits into two families that drive which logger renders and
// which table the data lands in:
//   set-shaped   weight_reps, weight_time, stretch  -> SetLogger, exercise_sets
//   cardio       cardio_basic, cardio_segments      -> CardioLogger, cardio_logs
//
// These existed as inline `=== 'weight_reps' || === 'weight_time'` checks in a
// dozen components. Centralised when 'stretch' was added, because that shape of
// check is exactly what a new set-shaped type has to be threaded through, and
// missing one silently renders an exercise with no inputs at all.

export const SET_BASED_TYPES = ['weight_reps', 'weight_time', 'stretch'];
export const CARDIO_TYPES = ['cardio_basic', 'cardio_segments'];

// True for anything logged as a list of sets.
export const usesSets = (type) => SET_BASED_TYPES.includes(type);

// True for anything logged as distance/duration.
export const isCardio = (type) => CARDIO_TYPES.includes(type);

// Stretches are set-shaped but every field is optional, they carry a free-text
// resistance, and they are excluded from personal records and exercise search.
export const isStretch = (type) => type === 'stretch';

// Which columns a set-shaped exercise offers. A stretch offers both, because it
// may be held for time, done for reps, or both.
export const hasReps = (type) => type === 'weight_reps' || type === 'stretch';
export const hasDuration = (type) => type === 'weight_time' || type === 'stretch';

// Human labels, shared by the library table, pickers and print views.
export const EXERCISE_TYPE_LABELS = {
  weight_reps: 'Weight & Reps',
  weight_time: 'Weight & Time',
  cardio_basic: 'Cardio',
  cardio_segments: 'Cardio Intervals',
  stretch: 'Stretch'
};
